import { Col, Skeleton, Space, Typography } from 'antd';
import { Controller, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CreateTicketFormValues } from '../../../../../../../types/form';
import CustomField from '../../../../../../components/CustomField';
import useAgentFormById from '../../../../../../hooks/ticketDetailPage/useAgentFormById';
import useFieldDefinitionByKey from '../../../../../../hooks/ticketDetailPage/useFieldDefinitionByKey';
import { FieldRequirement, TicketSystemFieldsKey, TicketSystemFieldsKeyMap } from '../../../../../../model/types';
import { getFieldRuleByKey } from '../../../../../../utils/forms/formHelper.util';
import { getValidationRules } from '../../../../../../utils/forms/formHelper.validators';
import {
    ConditionController,
    FORM_FIELD_KEY,
    ListenedConditionController,
    generateReactHookFormFriendlyFieldName
} from '../../AgentFormActiveFieldsContainer';

export default function EmailCcSection() {
    const { t } = useTranslation('forms');

    const formId = useWatch<CreateTicketFormValues, typeof FORM_FIELD_KEY>({ name: FORM_FIELD_KEY });
    const currentAgentForm = useAgentFormById(Number(formId));
    const emailCCFieldDefinition = useFieldDefinitionByKey(TicketSystemFieldsKey.emailCc);

    if (!emailCCFieldDefinition) return <Skeleton.Input active className="full-width" />;

    const fieldRuleOnForm = currentAgentForm?.fields?.find(getFieldRuleByKey(emailCCFieldDefinition));

    return (
        <Space className="full-width email-cc-input">
            <Typography.Text>{`${t('Email CCs')}:`}</Typography.Text>
            <Col span={24}>
                <Controller<CreateTicketFormValues, `fields.${typeof TicketSystemFieldsKeyMap.emailCc}`>
                    name={generateReactHookFormFriendlyFieldName(emailCCFieldDefinition.key)}
                    render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => (
                        <>
                            {fieldRuleOnForm?.conditions && (
                                <ConditionController
                                    fieldKey={emailCCFieldDefinition.key}
                                    conditions={fieldRuleOnForm.conditions}
                                />
                            )}
                            <ListenedConditionController
                                listenedConditionOnForm={fieldRuleOnForm?.listenedConditionOnForm}
                            >
                                <CustomField
                                    antdProps={{
                                        size: 'small',
                                        className: 'full-width'
                                    }}
                                    containerProps={{
                                        noLabel: true,
                                        errorMessage: error?.message,
                                        fieldRequirement:
                                            (fieldRuleOnForm?.listenedConditionOnForm?.action
                                                ?.required as FieldRequirement) ||
                                            fieldRuleOnForm?.required ||
                                            emailCCFieldDefinition?.required
                                    }}
                                    fieldDefinition={emailCCFieldDefinition}
                                    value={value}
                                    onBlur={onBlur}
                                    onChange={onChange}
                                />
                            </ListenedConditionController>
                        </>
                    )}
                    rules={{
                        validate: getValidationRules({
                            fieldRuleOnForm,
                            fieldDefinition: emailCCFieldDefinition
                        })
                    }}
                />
            </Col>
        </Space>
    );
}
